<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    hash : {{ hash }}
  </div>
</template>

<script>
import { COMMIT_HASH } from "@/constant"
export default {
  name: 'Home',
  data () {
    return {
      hash : COMMIT_HASH,
    }
  },
  methods: {
    // 結果の登録(追記)
    updateApp: function() {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
img {
  width: 100vw;
}
</style>